
export default {
    name: 'historique-paiement',
    components: {},
    props: ["liste_historique_paiement_dette", "dette_historique"],
    data() {
        return {
            is_empty_1: false,
            is_loading_1: true,
            fields: [
                'date', { key: 'montant_initial', label: 'Montant initial' },
                { key: 'montant_regle', label: 'Montant réglé' }, { key: 'montant_restant', label: 'Montant restant' }
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,

            modal_title: 'Historique de paiement',
            dette_period: '',
            dette_type_period: ''
        }
    },

    computed: {

    },

    mounted() {
        if (this.liste_historique_paiement_dette.length > 0) {
            this.is_empty_1 = false
        } else {
            this.is_empty_1 = true
        }

        setTimeout(() => {
            this.is_loading_1 = false
        }, 1000);
        
    },

    methods: {
        
    }
}


